import { Runtime } from '@/config/app'
import { useLocalStorage } from 'usehooks-ts'
import { useStartRoute } from '@/lib/react-query'

export const usePreferredRuntime = () => {
  return useLocalStorage('preferredRuntime', Runtime.Python3)
}

export const useStartPreferredRoute = (projectId: number): [(runtime: Runtime) => void, boolean] => {
  const [preferredRuntime, setPreferredRuntime] = usePreferredRuntime()

  const startProject = useStartRoute(projectId)

  const startPreferredRoute = (runtime: Runtime) => {
    if (runtime !== preferredRuntime) {
      setPreferredRuntime(runtime)
    }

    return startProject.mutate({ runtime })
  }

  return [startPreferredRoute, startProject.isPending]
}
